module.exports = __webpack_public_path__ + "static/media/oftalmolaser.72213259.png";